import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Menu } from 'antd';
import { Plugin, PluginKey } from 'prosemirror-state';
import { InputRule, inputRules } from 'prosemirror-inputrules';
import { Decoration, DecorationSet } from 'prosemirror-view';
import cx from 'classnames';
import { mention } from './nodes/mention';
import './Mention.scss';
import { getDropdownItem, getLabelItem } from '../../utils/menu';
const AT_OPERATOR = '@';
class MentionList extends PureComponent {
  constructor(props) {
    super(props);
    this.menuContainer = /*#__PURE__*/React.createRef();
    this.activeMenu = /*#__PURE__*/React.createRef();
  }
  getSnapshotBeforeUpdate(prevProps) {
    const {
      activeIndex
    } = this.props;
    const menuContainer = this.menuContainer;
    const activeMenu = this.activeMenu;
    if (activeIndex !== prevProps.activeIndex && menuContainer && activeMenu) {
      const {
        offsetHeight: activeMenuHeight
      } = activeMenu;
      const {
        clientHeight: menuContainerHeight,
        scrollTop,
        currentStyle
      } = menuContainer;
      const activeMenuTop = activeIndex * activeMenuHeight;
      const activeMenuBottom = activeMenuTop + activeMenuHeight;
      const menuContainerStyle = currentStyle || window.getComputedStyle(menuContainer);
      const paddingTop = parseInt(menuContainerStyle.paddingTop, 10);
      const paddingBottom = parseInt(menuContainerStyle.paddingBottom, 10);
      const dropdownHeight = menuContainerHeight - paddingTop - paddingBottom;
      const withInBoundary = dropdownHeight >= activeMenuTop && dropdownHeight >= activeMenuBottom;
      if (!withInBoundary) {
        return activeMenuBottom - dropdownHeight;
      }
      if (scrollTop > activeMenuTop) {
        return activeMenuTop;
      }
    }
    return null;
  }
  componentDidUpdate(prevProps, prevState, snapShot) {
    if (snapShot !== null) {
      const {
        menuContainer
      } = this;
      menuContainer.scrollTop = snapShot;
    }
  }
  render() {
    const {
      suggestions,
      wrapperStyle,
      mentionListClassName,
      activeIndex,
      onSelect,
      includeValueInLabel,
      itemRenderer
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      ref: ele => {
        this.menuContainer = ele;
      },
      className: cx('tap-mentionlist', mentionListClassName),
      style: wrapperStyle
    }, /*#__PURE__*/React.createElement(Menu, {
      mode: "inline"
    }, suggestions.map((suggestion, index) => /*#__PURE__*/React.createElement(Menu.Item, {
      key: suggestion.email,
      ref: node => {
        if (index === activeIndex) {
          this.activeMenu = ReactDOM.findDOMNode(node);
        }
      },
      className: cx('tap-mentionitem', {
        active: index === activeIndex
      }),
      onClick: () => onSelect(suggestion)
    }, itemRenderer ? itemRenderer(suggestion) : /*#__PURE__*/React.createElement("span", {
      title: suggestion.email
    }, suggestion.name || "".concat(suggestion.firstName, " ").concat(suggestion.lastName), " ", includeValueInLabel ? "<".concat(suggestion.email, ">") : ''))), suggestions.length <= 0 && /*#__PURE__*/React.createElement(Menu.Item, {
      key: "no-results",
      className: "tap-mentionitem",
      disabled: true
    }, /*#__PURE__*/React.createElement("span", null, "No results found"))));
  }
}
MentionList.propTypes = {
  onSelect: PropTypes.func.isRequired,
  suggestions: PropTypes.array,
  wrapperStyle: PropTypes.object,
  mentionListClassName: PropTypes.string,
  activeIndex: PropTypes.number,
  includeValueInLabel: PropTypes.bool,
  maxItemsPerPage: PropTypes.number
};
MentionList.defaultProps = {
  suggestions: [],
  wrapperStyle: {},
  mentionListClassName: '',
  activeIndex: 0,
  includeValueInLabel: false,
  maxItemsPerPage: 10
};
const pluginKey = new PluginKey('mention');
const getNewState = () => ({
  active: false,
  range: {
    from: 0,
    to: 0
  },
  text: '',
  index: 0,
  suggestions: [],
  allSuggestions: [],
  decorations: DecorationSet.empty
});
const dropdownRef = /*#__PURE__*/React.createRef();
const wrapperId = 'tap-editor-mentionlist-wrapper';
const onSelectSuggestion = (view, pluginState, suggestion) => {
  if (!suggestion) {
    return false;
  }
  const attrs = {
    name: suggestion.name || suggestion.label,
    id: suggestion.id,
    trigger: pluginState.mentionTrigger
  };
  if (suggestion.value) {
    attrs.value = suggestion.value;
  } else {
    attrs.email = suggestion.email;
  }
  const node = view.state.schema.nodes.mention.create(attrs);
  const tr = view.state.tr.replaceWith(pluginState.range.from, pluginState.range.to, node);
  const meta = {
    action: 'remove'
  };
  tr.setMeta(pluginKey, meta);
  view.dispatch(tr);
  const nextPos = pluginState.range.from + node.nodeSize;
  view.dispatch(view.state.tr.replaceWith(nextPos, nextPos, view.state.schema.text(' ')));
  view.focus();
};
const showDropdown = (view, state, suggestions) => {
  const pluginState = state;
  // Calculate postion
  const node = view.domAtPos(view.state.selection.$from.pos);
  const paraDOM = node.node;
  const editorDOM = paraDOM.closest('.tap-editor');
  const textDOM = paraDOM.querySelector(".".concat(pluginState.suggestionClassName));
  const style = {};
  if (textDOM) {
    const {
      top,
      left
    } = textDOM.getBoundingClientRect();
    const {
      left: editorLeft,
      width: editorWidth
    } = editorDOM.getBoundingClientRect();
    const dropdownWidth = 250;
    const editorRight = editorLeft + editorWidth;
    if (pluginState.position === 'top') {
      const dropdownHeight = 25 + (suggestions.length >= 7 ? 280 : 34 + (suggestions.length - 1) * 42);
      style.top = "".concat(top - dropdownHeight, "px");
    } else {
      style.top = "".concat(textDOM.offsetHeight + top, "px");
    }
    if (left + dropdownWidth > editorRight) {
      style.left = "".concat(editorRight - dropdownWidth - 10, "px");
    } else {
      style.left = "".concat(left, "px");
    }
  }
  let wrapper = document.getElementById(wrapperId);
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.setAttribute('id', wrapperId);
    document.body.appendChild(wrapper);
  }
  pluginState.active = true;
  pluginState.suggestions = suggestions;
  ReactDOM.render( /*#__PURE__*/React.createElement(MentionList, {
    ref: dropdownRef,
    suggestions: suggestions,
    wrapperStyle: style,
    mentionListClassName: pluginState.mentionListClassName,
    activeIndex: pluginState.index,
    onSelect: suggestion => onSelectSuggestion(view, pluginState, suggestion),
    includeValueInLabel: pluginState.includeValueInLabel,
    itemRenderer: state.itemRenderer
  }), wrapper);
};
const hideDropdown = () => {
  if (dropdownRef.current) {
    ReactDOM.unmountComponentAtNode(document.getElementById(wrapperId));
  }
};
const inSuggestion = (selection, decorations) => {
  return decorations.find(selection.from, selection.to).length > 0;
};
const shouldAllowSpace = (allowSpace, triggerSymbol, minSearchLength) => {
  const commonRegex = "(^|\\s)".concat(triggerSymbol, "([\\w-\\+]").concat(minSearchLength === 0 ? '*' : '+');
  return allowSpace ? new RegExp("".concat(commonRegex, "\\s?[\\w-\\+]*)$")) : new RegExp("".concat(commonRegex, ")$"));
};
const getMatch = ($position, pluginState) => {
  const text = $position.doc.textBetween($position.before(), $position.pos, '\n', '\0');
  const triggerSymbol = pluginState.mentionTrigger || AT_OPERATOR;
  const regex = pluginState.customRegex instanceof RegExp ? pluginState.customRegex : shouldAllowSpace(pluginState.allowSpace, triggerSymbol, pluginState.minSearchLength);
  const match = text.match(regex);
  if (match) {
    // Adjust match.index to remove the matched extra space
    match.index = match[0].startsWith(' ') ? match.index + 1 : match.index;
    match[0] = match[0].startsWith(' ') ? match[0].substring(1, match[0].length) : match[0];
    const from = $position.start() + match.index;
    const to = from + match[0].length;
    const queryText = match[2] || '';
    return {
      range: {
        from,
        to
      },
      queryText
    };
  }
  return null;
};
const configureMentionPlugin = options => {
  const plugin = new Plugin({
    key: pluginKey,
    state: {
      init() {
        return getNewState();
      },
      apply(tr, pluginState) {
        const meta = tr.getMeta(plugin);
        let newState = _objectSpread({}, pluginState);
        const {
          selection
        } = tr;
        const $position = selection.$from;
        if (selection.from !== selection.to) {
          return newState;
        }
        if ((meta === null || meta === void 0 ? void 0 : meta.action) === 'add') {
          const {
            type
          } = meta;
          const {
            range,
            queryText
          } = getMatch($position, type);
          const decorations = DecorationSet.create(tr.doc, [Decoration.inline(range.from, range.to, {
            nodeName: 'span',
            class: type.suggestionClassName
          })]);
          newState = _objectSpread(_objectSpread({}, getNewState()), type);
          newState.active = true;
          newState.range = range;
          newState.queryText = queryText.toLocaleLowerCase();
          newState.suggestions = type.allSuggestions.slice(0, 10);
          newState.decorations = decorations;
          return newState;
        } else if ((meta === null || meta === void 0 ? void 0 : meta.action) === 'remove') {
          return getNewState();
        } else {
          const match = getMatch($position, pluginState);
          if (match) {
            const {
              range,
              queryText
            } = match;
            const decorations = DecorationSet.create(tr.doc, [Decoration.inline(range.from, range.to, {
              nodeName: 'span',
              class: pluginState.suggestionClassName
            })]);
            newState.active = true;
            newState.range = range;
            newState.queryText = queryText.toLocaleLowerCase();
            newState.decorations = decorations;
            return newState;
          }
        }
        newState.active = false;
        newState.decorations = DecorationSet.empty;
        return newState;
      }
    },
    props: {
      decorations(editorState) {
        const {
          active,
          decorations
        } = this.getState(editorState);
        if (!active) return null;
        return decorations;
      },
      handleDOMEvents: {
        blur: view => {
          setTimeout(() => {
            if (!view.hasFocus()) {
              hideDropdown();
            }
          }, 500);
        },
        keydown(view, e) {
          const state = this.getState(view.state);
          if (!state.active || !state.suggestions.length || !inSuggestion(view.state.selection, state.decorations)) {
            return false;
          }
          const enter = e.keyCode === 13;
          const down = e.keyCode === 40;
          const up = e.keyCode === 38;
          const esc = e.keyCode === 27;
          if (down) {
            e.preventDefault();
            state.index += 1;
            state.index = state.index === state.suggestions.length ? 0 : state.index;
            showDropdown(view, state, state.suggestions);
            return true;
          }
          if (up) {
            e.preventDefault();
            state.index -= 1;
            state.index = state.index === -1 ? state.suggestions.length - 1 : state.index;
            showDropdown(view, state, state.suggestions);
            return true;
          }
          if (enter) {
            const suggestion = state.suggestions[state.index];
            if (!suggestion) {
              return false;
            }
            e.preventDefault();
            onSelectSuggestion(view, state, suggestion);
            return true;
          }
          if (esc) {
            hideDropdown();
            this.state = getNewState();
            return true;
          }
          return false;
        }
      }
    },
    view() {
      return {
        update: (view, prevState) => {
          const prev = this.key.getState(prevState);
          const next = this.key.getState(view.state);
          const started = !prev.active && next.active;
          const stopped = prev.active && !next.active;
          const changed = next.active && !started && !stopped && prev.queryText !== next.queryText;
          if (stopped) {
            hideDropdown();
            return;
          }
          if (next.getSuggestions && (started || changed)) {
            next.getSuggestions(next.queryText, suggestions => {
              showDropdown(view, next, suggestions);
            });
            return;
          }
          if (started || changed) {
            const suggestions = next.minSearchLength === 0 && !next.queryText ? next.allSuggestions.slice(0, next.maxSuggestions) : next.allSuggestions.filter(suggestion => {
              const {
                name,
                email,
                label,
                value
              } = suggestion;
              return name ? "".concat(name, " ").concat(email).toLocaleLowerCase().includes(next.queryText) : "".concat(label, " ").concat(value).toLocaleLowerCase().includes(next.queryText);
            }).slice(0, next.maxSuggestions);
            showDropdown(view, next, suggestions);
          }
        }
      };
    }
  });
  return plugin;
};
export default {
  name: 'mention',
  defaultOptions: {
    allowSpace: true,
    suggestionClassName: 'tap-editor-suggestion',
    mentionListClassName: '',
    suggestions: [],
    hidePrefixAndSuffix: false,
    mentionTrigger: AT_OPERATOR,
    minSearchLength: 1,
    maxSuggestions: 20,
    itemRenderer: null
  },
  configure: options => {
    const rules = [];
    const plugin = configureMentionPlugin(options);
    const pluginOptions = Array.isArray(options) ? options : [options];
    const menuItems = [];
    const insertPlaceholder = (selectedOption, pluginState) => (state, dispatch, view) => {
      var _selection$$cursor;
      const {
        selection
      } = state.tr;
      const $position = (_selection$$cursor = selection.$cursor) === null || _selection$$cursor === void 0 ? void 0 : _selection$$cursor.pos;
      if (dispatch && $position) {
        const range = {
          from: $position,
          to: $position
        };
        onSelectSuggestion(view, _objectSpread(_objectSpread({}, pluginState), {}, {
          range
        }), selectedOption);
        return true;
      }
      return true;
    };
    pluginOptions.forEach((option, index) => {
      const {
        customRegex,
        mentionTrigger,
        suggestions,
        allowSpace,
        minSearchLength,
        showInMenu,
        menuPlaceholder
      } = option;
      let trigger = mentionTrigger || AT_OPERATOR;
      const rule = inputRules({
        rules: [new InputRule(customRegex || shouldAllowSpace(allowSpace, trigger, minSearchLength), (state, match) => {
          const {
            decorations
          } = plugin.getState(state);
          // If we are currently suggesting, don't activate
          if (inSuggestion(state.selection, decorations)) return null;
          // We are taking over the text input here
          const tr = state.tr.insertText(match['input'][match['input'].length - 1]).scrollIntoView();
          const type = _objectSpread(_objectSpread({}, option), {}, {
            name: "mention".concat(mentionTrigger || '@'),
            allSuggestions: suggestions.map(_ref => {
              let {
                name,
                email,
                label,
                value,
                firstName,
                lastName,
                id,
                _id
              } = _ref;
              const suggestion = {
                name,
                email,
                value,
                id: id || _id
              };
              if (label) {
                suggestion.name = label;
                suggestion.email = value;
                return suggestion;
              }
              if (name) {
                return suggestion;
              }
              if (firstName && lastName) {
                suggestion.name = "".concat(firstName, " ").concat(lastName);
              } else {
                suggestion.name = email;
              }
              return suggestion;
            })
          });
          const meta = {
            action: 'add',
            type
          };
          tr.setMeta(plugin, meta);
          return tr;
        })]
      });
      rules.push(rule);
      if (showInMenu) {
        const dropdownItems = suggestions.map(suggestion => {
          const {
            label,
            name
          } = suggestion;
          const labelValue = label || name;
          return getLabelItem(labelValue.toLowerCase().replace(/[.\s]/, '-'), labelValue, '', insertPlaceholder(suggestion, option));
        });
        if (dropdownItems.length > 0) {
          menuItems.push(getDropdownItem("insert-placeholders".concat(index), "".concat(menuPlaceholder || 'Select'), dropdownItems));
        }
      }
    });
    return {
      nodes: {
        mention: mention(pluginOptions)
      },
      plugins: [plugin, ...rules],
      menuItems
    };
  }
};